import { IssueCategoryEnum, IssueStatusEnum, IssueTypeEnum } from '../types';
// Using status type directly
const mockIssues = [
    {
        id: 1,
        description: 'Control valve question requires attention',
        issueType: IssueTypeEnum.UnansweredQuestion,
        active: true,
        status: IssueStatusEnum.Detected,
        issueCategory: IssueCategoryEnum.UnansweredQuestions,
        managerNote: null,
        markedForSuggestion: false,
        issueData: {
            highImpact: true,
            randomKey: 'random_data'
        },
        isMultitech: false,
        inspectable: {
            id: 456,
            type: 'Valve',
            data: {
                location: 'Control Valve Area',
                type: 'Control Valve',
                manufacturer: 'Johnson Controls',
                model: 'CV-2000',
                serialNumber: 'JC45678912',
                installationDate: '2020-03-15',
                lastInspection: '2023-07-10'
            }
        },
        inspectionManagerRunId: null,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        // feedbackState removed - using status instead
        question: {
            id: 123,
            type: 'ValveQuestion',
            dataStructure: 'full',
            data: {
                code: null,
                codeYear: '2018',
                esQuestionText: '¿Las válvulas de control están supervisadas con sellos en la posición correcta (abierta o cerrada)?',
                frQuestionText: 'Les vannes de contrôle sont-elles surveillées avec des scellés en position correcte (ouverte ou fermée)?',
                frSection: 'QUESTIONS',
                frequencyType: 1,
                ignoreDeficiency: false,
                isUserAdded: false,
                latestAnswer: null,
                questionText: 'Are the control valves supervised with seals in correct (open or closed) position?',
                questionType: 'YesNo',
                section: 'QUESTIONS',
                sectionNumber: null,
                showOnReport: true,
                tceQuestionIds: [],
                createdAt: '2016-11-01T11:21:53.520-04:00',
                updatedAt: '2025-05-09T08:09:10.343-04:00',
                systemId: 'valve_question_1'
            }
        }
    },
    {
        id: 2,
        description: 'Grammar correction needed in notes',
        issueType: IssueTypeEnum.AnalyzeDeficiencyNotes,
        issueCategory: IssueCategoryEnum.GrammarAndStyle,
        active: true,
        status: IssueStatusEnum.Detected,
        managerNote: null,
        markedForSuggestion: false,
        issueData: {
            attributeKey: 'notes',
            before: 'Unit did not respond at set temperature threshold.',
            after: 'Unit did not respond at the set temperature threshold.'
        },
        isMultitech: false,
        inspectable: {
            id: 0,
            type: 'Document',
            data: {
                documentType: 'Deficiency Report',
                section: 'Fire Extinguishers',
                author: 'Jane Doe',
                reportNumber: 'DEF-2023-078'
            }
        },
        inspectionManagerRunId: null,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
        // feedbackState removed - using status instead
    },
    {
        id: 3,
        description: 'Missing response for sprinkler system inspection',
        issueType: IssueTypeEnum.UnansweredQuestion,
        active: true,
        status: IssueStatusEnum.Detected,
        issueCategory: IssueCategoryEnum.UnansweredQuestions,
        managerNote: null,
        markedForSuggestion: false,
        issueData: {
            highImpact: true,
            randomKey: 'random_data'
        },
        isMultitech: false,
        inspectable: {
            id: 789,
            type: 'SprinklerSystem',
            data: {
                location: 'Sprinkler System Area',
                type: 'Sprinkler System',
                manufacturer: 'Viking',
                model: 'FireGuard 3000',
                serialNumber: 'VK789123456',
                installationDate: '2019-11-22',
                lastInspection: '2023-08-05',
                coverage: '5000 sq ft',
                pipeSize: '2 inch'
            }
        },
        inspectionManagerRunId: null,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        // feedbackState removed - using status instead
        question: {
            id: 456,
            type: 'SprinklerSystemQuestion',
            dataStructure: 'full',
            data: {
                code: 'NFPA 25',
                codeYear: '2020',
                esQuestionText: '¿Se ha probado el sistema de rociadores según los requisitos de NFPA?',
                frQuestionText: 'Le système de gicleurs a-t-il été testé conformément aux exigences de la NFPA?',
                frSection: 'QUESTIONS',
                frequencyType: 1,
                ignoreDeficiency: false,
                isUserAdded: false,
                latestAnswer: null,
                questionText: 'Has the sprinkler system been tested according to NFPA requirements?',
                questionType: 'YesNo',
                section: 'QUESTIONS',
                sectionNumber: null,
                showOnReport: true,
                tceQuestionIds: [],
                createdAt: '2017-05-12T09:45:22.120-04:00',
                updatedAt: '2025-04-15T14:22:33.781-04:00',
                systemId: 'sprinkler_system_1'
            }
        }
    },
    {
        id: 4,
        description: 'Fire alarm panel inspection required',
        issueType: IssueTypeEnum.UnansweredQuestion,
        active: true,
        status: IssueStatusEnum.Detected,
        issueCategory: IssueCategoryEnum.UnansweredQuestions,
        managerNote: null,
        markedForSuggestion: false,
        issueData: {
            highImpact: true,
            randomKey: 'random_data'
        },
        isMultitech: false,
        inspectable: {
            id: 101,
            type: 'FireAlarmPanel',
            data: {
                location: 'Main Control Room',
                type: 'Fire Alarm Panel',
                manufacturer: 'Honeywell',
                model: 'Notifier NFS-320',
                serialNumber: 'HW123456789',
                installationDate: '2021-02-10',
                lastInspection: '2023-09-15',
                zonesCovered: '1, 2, 3, 4',
                batteryBackup: 'Yes - 24 hours'
            }
        },
        inspectionManagerRunId: null,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        // feedbackState removed - using status instead
        question: {
            id: 789,
            type: 'FireAlarmQuestion',
            dataStructure: 'full',
            data: {
                code: 'NFPA 72',
                codeYear: '2019',
                esQuestionText: '¿Está el panel de alarma contra incendios en condiciones normales de funcionamiento?',
                frQuestionText: "Le panneau d'alarme incendie est-il en état de fonctionnement normal?",
                frSection: 'QUESTIONS',
                frequencyType: 1,
                ignoreDeficiency: false,
                isUserAdded: false,
                latestAnswer: null,
                questionText: 'Is the fire alarm panel in normal operating condition?',
                questionType: 'YesNo',
                section: 'QUESTIONS',
                sectionNumber: null,
                showOnReport: true,
                tceQuestionIds: [],
                createdAt: '2018-03-22T14:12:45.330-04:00',
                updatedAt: '2025-03-18T11:05:27.492-04:00',
                systemId: 'fire_alarm_1'
            }
        }
    },
    {
        id: 5,
        description: 'Grammar correction in deficiency notes',
        issueType: IssueTypeEnum.AnalyzeDeficiencyNotes,
        active: true,
        status: IssueStatusEnum.Detected,
        issueCategory: IssueCategoryEnum.GrammarAndStyle,
        inspectionManagerRunId: 1,
        isMultitech: false,
        inspectable: {
            id: 202,
            type: 'Document',
            data: {
                documentType: 'Deficiency Report',
                section: 'Fire Extinguishers',
                author: 'Jane Doe',
                reportNumber: 'DEF-2023-078'
            }
        },
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        // feedbackState removed - using status instead
        markedForSuggestion: false,
        issueData: {
            attributeKey: 'deficiency_notes',
            before: 'Fire extinguisher need to be replaced.',
            after: 'Fire extinguisher needs to be replaced.'
        }
    },
    {
        id: 6,
        description: 'Emergency lighting check required',
        issueType: IssueTypeEnum.UnansweredQuestion,
        active: true,
        status: IssueStatusEnum.Detected,
        issueCategory: IssueCategoryEnum.UnansweredQuestions,
        inspectionManagerRunId: 1,
        isMultitech: false,
        inspectable: {
            id: 505,
            type: 'Emergency Light',
            data: {
                location: 'Exit Hallway',
                manufacturer: 'Lithonia',
                model: 'ELM2',
                serialNumber: 'LT505606',
                installationDate: '2021-05-15',
                batteryType: 'Lithium-Ion',
                runTime: '90 minutes',
                mountingHeight: '8 feet'
            }
        },
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        // feedbackState removed - using status instead
        markedForSuggestion: false,
        issueData: {
            highImpact: false,
            questionText: 'Are all emergency lights functioning properly during the 90-minute test?',
            questionType: 'emergency_systems',
            answerText: null,
            inspectableName: 'Emergency Lighting System'
        }
    }
];
const mockIssuesStore = [...mockIssues];
export function getMockIssues(inspectionId) {
    console.log({ inspectionId });
    return mockIssuesStore;
}
// Store for mock issues to maintain state between calls
export function updateMockIssue(issueId, status, managerNote) {
    const issueIndex = mockIssuesStore.findIndex((issue) => issue.id === issueId);
    if (issueIndex === -1) {
        throw new Error(`Issue with id ${issueId} not found`);
    }
    mockIssuesStore[issueIndex] = Object.assign(Object.assign({}, mockIssuesStore[issueIndex]), { status, managerNote: managerNote || mockIssuesStore[issueIndex].managerNote });
    return mockIssuesStore[issueIndex];
}
export function bulkUpdateMockIssues(inspectionId, status) {
    const updatedIssues = [];
    mockIssues
        .map((issue) => issue.id)
        .forEach((issueId) => {
        try {
            const updatedIssue = updateMockIssue(issueId, status);
            updatedIssues.push(updatedIssue);
        }
        catch (error) {
            console.error(`Error updating issue ${issueId}:`, error);
        }
    });
    return updatedIssues;
}
// For backward compatibility
export default getMockIssues;
